import React from 'react';
import PropTypes from 'prop-types';
import { FileInput } from 'wix-rich-content-ui-components';
import { BUTTON_TYPES } from 'wix-rich-content-editor-common';
import { GiphyIcon } from '../../icons/giphy-icon';
import styles from './external-plugin-toolbar.scss';

const ExternalToolbar = ({ buttons }) => {
  const renderButton = ({ name, onClick, getIcon, dataHook }) => {
    const Icon = name === 'GIFPlugin_InsertButton' ? GiphyIcon : getIcon();

    return (
      <button className={styles.pluginButton} onClick={onClick} data-hook={dataHook}>
        <Icon className="forum-icon-fill" />
      </button>
    );
  };

  const renderFileButton = ({ name, getIcon, onChange, accept, multiple, dataHook }) => {
    const Icon = getIcon();
    return (
      <FileInput
        className={styles.pluginButton}
        onChange={onChange}
        accept={accept}
        key={name}
        multiple={multiple}
        dataHook={dataHook}
      >
        <Icon className="forum-icon-fill" />
      </FileInput>
    );
  };

  return (
    <div className={styles.container}>
      {Object.values(buttons).map(buttonProps =>
        buttonProps.type === BUTTON_TYPES.FILE
          ? renderFileButton(buttonProps)
          : renderButton(buttonProps),
      )}
    </div>
  );
};

ExternalToolbar.propTypes = {
  buttons: PropTypes.object.isRequired,
  renderPluginButtons: PropTypes.bool.isRequired,
};

export default ExternalToolbar;
